import React,{useState,useEffect, useRef} from 'react';
import { Routes, Route, Outlet,Link, useNavigate } from "react-router-dom";
import "./Header.css"
import {msalInstance} from '../../index';
import Tooltip from '@mui/material/Tooltip';
import Avatar from '@mui/material/Avatar';
import { useDispatch, useSelector } from 'react-redux';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useTranslation, initReactI18next } from "react-i18next";
import Button from '@mui/material/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import  config  from '../../env.json';
import UserIcon from '../../assets/icons/profile-user.svg'


function stringAvatar(name: string) {
  return {
    sx: { 
      cursor:"pointer",
      bgcolor: "#ffffff",
      color:document.documentElement.style.getPropertyValue('--primary-color'),
      fontSize:"1rem",
      width:"35px",
      height:"35px"
    },
    children: name ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}` : ' ',
  };
}

function Header() {
  const { t } = useTranslation();
  const [showProfilebar,setShowProfilebar]=useState(false);
  const userName=useSelector((state:any)=>state.authApiSlice.EmployeeFull_Nm);
  const userEmail=useSelector((state:any)=>state.authApiSlice.EmployeeEmail_Adr);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  let menuRef = useRef<any>('');
 
  
  useEffect(() => {
    let handler = (e:any)=>{
      if(!menuRef?.current.contains(e.target)){
        setOpen(false);   
      }
    };

    document.addEventListener("mousedown", handler);
    

    return() =>{
      document.removeEventListener("mousedown", handler);
    }

  });

const logout=()=>{
    let account=sessionStorage.getItem('loginName') as string
      msalInstance.logoutRedirect({
        account: msalInstance.getAccountByUsername(account)
    }).catch((e:any) => {
        console.log(e);
      });
}

const handleNavigateToSwitchClient=()=>{
  setOpen(false);     
  navigate("/switchclient");
}


  return (
    <>
    <div className='header-div'>
      {/* <Button className='profile-btn' onClick={()=>setShowProfilebar(true)}>{userName}</Button> */}

      <div className='page-name-div'>
          {/* H3 tag will be empty ,it has been made dynamic using CSS */}
          <h3  id="page-name" data-content=""></h3> 
          
        </div>

      <div className='profile-inner-div-right'>

            <div className='create-client-btn-section'>
            <Link
                  className="rounded-primary-40 btn font--btn export-flow-btn config-cancel-btn create-client-btn"
                  to={"/Create"}
                  // onClick={cancel}
                >
                <FontAwesomeIcon className='create-icon' icon={["fas", "plus-circle"]} size="lg"/>
                <div>Create</div>
                </Link>
            </div>
              <div className='profile-btn-icon-section' >
                <Tooltip title={t('View Profile')} arrow>
                  <Avatar {...stringAvatar(userName)} onClick={()=>{setOpen(!open)}}/>
                </Tooltip>
              </div>
            <div className='header-3dots-icon'>
              <FontAwesomeIcon className='create-icon' icon={["fas", "ellipsis-vertical"]} size="xl"/>
            </div>

          </div>

    </div>
    
    <div className={`profile-popup ${open? 'active' : 'inactive'}`} ref={menuRef}>
      <div className='profile-popup-header'>
        <div className='profile-popup-header-logo'>
        <div className='logo-img'>

          <img src={config.REACT_APP_LOGO} alt="Zing Logo" />

          </div>
        </div>
        <div className='profile-popup-header-btn'>
          <div onClick={logout} className='sign-out-btn'>Sign out</div>
          
        </div>
      </div>
      <div className='profile-popup-body'>
         <div className='profile-popup-body-icon content-center'>
         <img className='user-profile-icon' src={UserIcon} />
         </div>
         <div className='profile-popup-body-info content-center'>
            <div className="profile-popup-name">
              {userName}
            </div>
            <div className="profile-popup-email">
              {userEmail}
            </div>
            <div className="profile-popup-switch-btn">
            <div className='export-flow-btn-div'>
                <div
                  className="rounded-primary-40 btn font--btn switch-client-btn"   
                  onClick={handleNavigateToSwitchClient}           
                >
                <div>Switch Client</div>
                 
                </div>
              </div>

            </div>
         </div>
      </div>
    </div>


</>
          
  );
}

export default Header;
